import { WHATSAPP_PDF_TEXT } from '@modules/aawz-intelligence-v2/constants/Text'

// Payloads de snackbar (the-snackbar.vue: `button: {text, color, callback}`)
// para o fluxo "PDF baixado -> enviar para meu WhatsApp". Puros: as telas do
// consolidador não têm suíte própria, então a regra fica testável aqui.
//
// O que garante que vai o PDF certo: o `hash` fechado no callback é o MESMO
// que a tela acabou de gerar e baixar (`gerar -> checkStatusPDF -> download`),
// e o backend (`usecase_whatsapp_enviar_pdf`) só faz `APIPDF.download_pdf`
// por esse hash — reenvia o arquivo já no S3, nunca regera. Hash que ainda
// não terminou de gerar volta 404 ("ainda em geração"), não um PDF antigo.
const TIMEOUT_COM_ACAO_MS = 10000

export function snackComAcaoEnviar({ texto, onEnviar }) {
  return {
    text: texto,
    color: 'success',
    timeout: TIMEOUT_COM_ACAO_MS,
    button: { text: WHATSAPP_PDF_TEXT.acao, callback: onEnviar },
  }
}

// Envelope do backend (HTTP 200-always com `status` no corpo) -> snack.
export function snackDeEnvio(r) {
  const status = r && r.status
  const texto = (r && r.message) || WHATSAPP_PDF_TEXT.fallbackErro
  if (status === 200) return { text: texto, color: 'success', button: false }
  // 404 (ainda em geração) e 409 (sem número) são orientação, não falha.
  const color = status === 404 || status === 409 ? 'warning' : 'error'
  return { text: texto, color, button: true }
}
